var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-geo-json',{attrs:{"visible":_vm.visible,"name":_vm.name,"geojson":_vm.geojson,"layer-type":"overlay","options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }